export const FILTERS_ENUM = {
  journey: "Jornada",
  templates: "Template",
  interval: "Intervalo de tempo",
  journeyInterval: "Criação da Jornada",
  order: 'Ordenação'
};
